import axios from "axios"

export const getCnaes = async () => {
  return await axios.get('https://servicodados.ibge.gov.br/api/v2/cnae/classes');
}
